import { useBooleanFlagValue } from '@openfeature/react-sdk'
import { FEATURE_FLAG_KEYS } from '@/features/open-feature'

export const useHavenMessagesView = (): boolean =>
  useBooleanFlagValue(FEATURE_FLAG_KEYS.havenMessagesView, false)
